(function () {
  'use strict';

  function initGallery(container) {
    container.querySelectorAll('[data-jc-roomfit-gallery]:not([data-jc-gallery-ready])').forEach(gallery => {
      gallery.dataset.jcGalleryReady = 'true';
      const models = [];
      gallery.querySelectorAll('[data-jc-gallery-card]').forEach(card => {
        const button = card.querySelector('[data-jc-gallery-preview]');
        let product;
        try {
          product = JSON.parse(card.querySelector('[data-jc-gallery-data]').textContent);
          const chairModels = JSON.parse(card.querySelector('[data-jc-gallery-models]').textContent);
          if (!product.model || !Array.isArray(chairModels) || !chairModels.length) throw new Error('Chair model is missing');
          models.push(...chairModels);
        } catch (cause) {
          console.error('JC RoomFit: gallery chair unavailable', cause);
          button.disabled = true;
          button.insertAdjacentText('afterend', 'This chair preview is temporarily unavailable.');
          return;
        }
        if (!window.JCRoomFit) {
          console.error('JC RoomFit: 3D viewer is unavailable');
          button.disabled = true;
          button.insertAdjacentText('afterend', '3D preview is temporarily unavailable.');
        } else {
          window.JCRoomFit.attach(button, product, 'model');
        }
      });
      if (!models.length) return;
      if (!window.Shopify || !window.Shopify.loadFeatures) return;
      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: function (error) {
          if (error) { console.error('JC RoomFit: gallery AR could not load', error); return; }
          function setup() {
            if (!window.ShopifyXR) {
              document.addEventListener('shopify_xr_initialized', setup, { once: true });
              return;
            }
            window.ShopifyXR.addModels(models);
            window.ShopifyXR.setupXRElements();
          }
          setup();
        }
      }]);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGallery(document));
  else initGallery(document);
  document.addEventListener('shopify:section:load', event => initGallery(event.target));
}());
